import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './lawyer_modify_picture_wrapper.module.scss';

type Props = {
  canModify?: boolean;
};

export const LawyerModifyPictureWrapper: FC<Props> = ({
  children,
  canModify = true,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={styles.container}
    >
      {children}
      {isHovered && canModify && <LawyerModifyPicture />}
    </div>
  );
};

const LawyerModifyPicture: FC = () => (
  <div className={styles.modify}>
    <span className={styles.modifyText}>
      <FormattedMessage id="app.pages.lawyer.header.actions.modify" />
    </span>
  </div>
);
